<template>
  <span class="voxy-organization-filter">
    <voxy-dropdown
      id="organization-dropdown"
      v-if="canAccessMultipleOrganizations"
      ref="dropdown"
      :placeholder="placeholder"
      :menu-alignment="menuAlignment"
      :disabled="isDisabled"
      @on-open="onMenuOpen"
      @on-close="onMenuClose"
    >
      <voxy-datalist
        id="organization-dropdown-options"
        class="voxy-organization-filter__dropdown"
        ref="datalist"
        :options="organizations"
        :search-placeholder="searchPlaceholder"
        :value="organizationSelected"
        @input="onOrganizationChange"
      >
        <template slot="clear">
          <font-awesome-icon :icon="['fal', 'times']" />
        </template>
      </voxy-datalist>

      <div class="voxy-organization-filter__button" slot="button">
        {{ organizationSelected.name }}
        <span v-if="!organizationSelected.name">{{ placeholder }}</span>
        <i class="voxy-organization-filter__caret">
          <font-awesome-icon :icon="['fas', 'caret-down']" />
        </i>
      </div>
    </voxy-dropdown>
    <template v-else>
      <div v-if="organizationSelected" class="voxy-organization-filter__single-label">
        {{ organizationSelected.name }}
      </div>
    </template>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { VoxyDatalist, VoxyDropdown } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'VoxyOrganizationFilter',

  components: {
    FontAwesomeIcon,
    VoxyDatalist,
    VoxyDropdown,
  },

  async beforeMount() {
    await this.$store.dispatch('FETCH_ORGANIZATIONS');

    if (this.organizationId) {
      this.$store.dispatch('FETCH_FEATURE_GROUPS');
    }
  },

  data() {
    return {
      placeholder: 'Organization',
      searchPlaceholder: 'Filter organizations',
      menuAlignment: 'right',
      selectedOgranization: null,
    };
  },

  computed: {
    ...mapGetters(['organizations', 'organizationId']),
    canAccessMultipleOrganizations() {
      return this.organizations.length > 1;
    },
    isDisabled() {
      return this.organizations.length <= 1;
    },
    organizationSelected() {
      return this.organizations.find(org => org.id === this.organizationId);
    },
  },

  methods: {
    onOrganizationChange(organization) {
      this.$store.commit('SET_ORGANIZATION_ID', { organizationId: organization.id });
      this.$refs.dropdown.close();
    },

    onMenuOpen() {
      this.$nextTick(this.$refs.datalist.focus);
    },

    onMenuClose() {
      this.$refs.datalist.blur();
    },
  },

  watch: {
    organizationId() {
      this.$emit('changed', this.organizationId);
      this.$store.dispatch('FETCH_FEATURE_GROUPS');
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/mixins';
@import '~styles/tools/variables';

.voxy-organization-filter {
  margin: 0 40px;

  &:empty {
    margin: 0;
  }

  &__dropdown {
    padding: 5px 0;
    box-shadow: 0 5px 10px rgba(black, 0.25);
    background-color: $default-component-grey;
    border-radius: 5px;
  }

  &__caret {
    position: absolute;
    z-index: -1;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    transition: all 0.26s;

    .voxy-dropdown_open & {
      transform: translateY(-50%) rotate(180deg);
    }

    .voxy-dropdown_disabled & {
      display: none;
    }
  }

  &__button {
    font-size: 14px;
    position: relative;
    width: 100%;
    height: 30px;
    padding: 6px 30px 5px 12px;
    -webkit-appearance: none;
    white-space: nowrap;
    background-color: transparent;
    color: white;
    border-radius: 0;
    border-width: 1px;
    border-style: solid;

    .voxy-dropdown_disabled & {
      padding-right: 12px;
    }
  }

  &__single-label {
    font-size: 20px;
  }
}
</style>
